<div class="m-input-style"
     :class="[{ 'm--is-focus' : isFocus,
              'm--is-readonly': isReadonly,
              'm--is-label-up': isLabelUp,
              'm--is-disabled' : isDisabled,
              'm--is-waiting' : isWaiting,
              'm--has-cursor-pointer' : cursorPointer,
              'm--has-error' : hasError,
              'm--is-valid' : isValid,
              'm--has-label': hasLabel,
              'm--has-value': hasValue,
              'm--is-anim-ready': animReady },
              'm--is-tag-' + tagStyle]"
     @click="onClick"
     @mousedown="onMousedown"
     @mouseup="onMouseup"
     ref="root"
     :style="{ width: width, marginTop: labelOffset }">
    <div class="m-input-style__main">
        <div class="m-input-style__body">
            <label v-if="hasLabel"
                   class="m-input-style__label"
                   :style="{ marginRight: suffixOffset }"
                   :for="labelFor"
                   ref="label">
                <span class="m-input-style__text">
                    <span>{{ label }}</span>&nbsp;<sup v-if="requiredMarker"
                         class="m-input-style__required-marker">*</sup>
                </span>
            </label>

            <span v-else
                  class="m-input-style__label"
                  style="z-index: -1;">
                <span class="m-input-style__text">
                    <!-- this markup is mandatory to maintain content height and alignment -->
                </span>
            </span>

            <div class="m-input-style__input"
                 ref="input">

                <div v-if="showPrefix"
                     class="m-input-style__prefix"
                     ref="prefix">
                    <slot name="prefix"></slot>
                </div>

                <div class="m-input-style__content">
                    <slot></slot>
                    <m-i18n v-if="!hasDefaultSlot"
                            class="m-input-style__transparent-text"
                            k="m-input-style:empty-value"
                            aria-hidden="true"></m-i18n>
                    <div v-if="hasAdjustWidthAutoSlot"
                         class="m-input-style__adjust-width-auto"
                         aria-hidden="true"
                         ref="adjustWidthAuto">
                        <slot name="adjust-width-auto"></slot>
                    </div>
                </div>

                <div class="m-input-style__suffix"
                     ref="suffix">

                    <slot name="suffix"></slot>

                    <m-spinner v-if="isWaiting"
                               class="m-input-style__spinner"
                               size="small"></m-spinner>
                </div>
            </div>
        </div>
        <div v-if="append"
             ref="append"
             class="m-input-style__append">
            <slot name="append"></slot>
        </div>
    </div>
</div>
